module.exports = __webpack_public_path__ + "img/upload-rg.16d9ba38.jpg";